import { Component, inject, OnInit } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { MasterService } from "@frontend/app/serivces/master.service";
import { Cls_PaymentTransaction } from "@frontend/app/models/master";
import { SharedModule } from "@frontend/app/shared/shared.module";

@Component({
  selector: "app-add-payment",
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, CurrencyPipe],
  templateUrl: "./add-payment.component.html",
  styleUrl: "./add-payment.component.scss",
})
export class AddPaymentComponent implements OnInit {
  private masterService = inject(MasterService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  // --- State Properties (Replaced Signals) ---
  orderConfirmed = false;
  packages: any[] = [];
  studentID = 0;
  paymentModeMaster: any[] = [];
  classID = 0;

  // --- Form Data Model ---
  // Holds data for text inputs, etc.
  paymentData = new Cls_PaymentTransaction();
  // A dedicated property for the dropdown's ngModel
  selectedPackageId: number | undefined;

  // --- Getters (Replaced Computed Signals) ---
  // Reacts to changes in `selectedPackageId` via change detection
  get selectedPackage(): any {
    return this.packages.find(p => p.PackageID === this.selectedPackageId);
  }

  // Reacts to changes in `selectedPackage` or `paymentData.Discount`
  get totalAmount(): number {
    const amount = this.selectedPackage?.FinalAmount || 0;
    const discount = this.paymentData.Discount || 0;
    return Math.max(0, amount - discount);
  }

  // --- Lifecycle ---
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.studentID = +params["StudentID"];
      this.classID = +params["ClassID"];
      if (this.studentID) {
        this.getStudentDetails();
      }
    });
    this.getPackage();
    this.initializePaymentData();
    this.getPaymentModeMaster();
  }

  initializePaymentData(): void {
    this.paymentData = new Cls_PaymentTransaction();
    this.paymentData.Discount = 0;
    this.paymentData.PaymentMethod = "Cash";
  }

  getStudentDetails(): void {
    this.masterService.getStudentByID(this.studentID).subscribe((res: any) => {
      if (res.data) {
        const student = res.data;
        const firstName = student.FirstName || "";
        const middleName = student.MiddleName ? ` ${student.MiddleName}` : "";
        const lastName = student.LastName ? ` ${student.LastName}` : "";
        this.paymentData.PayeeName = `${firstName}${middleName}${lastName}`.trim();
        this.paymentData.PayeeMobileNo = student.MobileNo || "";
      }
    });
  }

  // --- Data Fetching ---
  getPackage() {
    this.masterService.getPackageList().subscribe((res: any) => {
      const activePackages = res.Table.filter((item: any) => item.IsActive);
      this.packages = activePackages; // Assign directly to the property

      // Set the default package ID on our property
      if (activePackages.length > 0) {
        this.selectedPackageId = activePackages[0].PackageID;
      }
    });
  }

  getPaymentModeMaster() {
    this.masterService.getPaymentModeMaster().subscribe((res: any) => {
      this.paymentModeMaster = res.Table;
    });
  }

  // --- Actions ---
  onSubmit() {
    const tempModal = new Cls_PaymentTransaction();
    tempModal.PTID = this.paymentData.PTID;
    tempModal.PayeeName = this.paymentData.PayeeName;
    tempModal.PayeeMobileNo = this.paymentData.PayeeMobileNo;
    tempModal.StudentID = this.studentID;
    tempModal.ClassID = this.classID;
    tempModal.PackageID = this.selectedPackageId; // Read property

    this.masterService.addPayment(tempModal).subscribe((res: any) => {
      this.orderConfirmed = true;
      this.router.navigate(["/member-enrolled-page"], { queryParams: { StudentID: this.studentID, ClassID: this.classID } });
    });
  }

  reset(): void {
    this.orderConfirmed = false;
    this.initializePaymentData();

    if (this.packages.length > 0) {
      this.selectedPackageId = this.packages[0].PackageID;
    }
  }
}
